export default "__VITE_ASSET__a3riyPyK__"